import { createFileRoute } from "@tanstack/react-router";

import { DashboardPage, dashboardSearchSchema } from "@/features/dashboard";

// «Дашборд» команды: экран целиком из фичи `dashboard`. Период — в search params, меняется
// без новой записи в истории браузера и без прокрутки наверх.
const DashboardRoute = () => {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DashboardPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true, resetScroll: false })}
    />
  );
};

export const Route = createFileRoute("/dashboard")({
  validateSearch: dashboardSearchSchema,
  component: DashboardRoute,
});
